import React, { Component } from "react"

import { searchifySelectGenericFilter } from "shared/search/containers/Filter/FilterCreators"

import { IssueManagementFilterableListView } from "shared/search/containers/FilterableListView/FilterableListViews"

import { IssueManagementSelect } from "app/static/frontend/selects/containers/PieSelect"

import isFeatureEnabled from "shared/featureflags/helperFunctions"

export class FileProjectFilter extends Component {
    static get defaultProps() {
        return {
            filterComponent: searchifySelectGenericFilter,
            uniqueFilterId: "FileProjectFilter",
            filterKey: "for_project_and_subprojects",
            searchifyFLV: IssueManagementFilterableListView,
            dataTypeLabel: "Issues",
            selectComponent: IssueManagementSelect,
        }
    }

    render() {
        const FilterComponent = this.props.filterComponent
        return <FilterComponent {...this.props} />
    }
}
